/**
 *  展示孤岛页面 如果需要展示在此处添加页面路由即可示例：
 *  /child-contentCenter/system/questionnaire 需要带子应用的名称
 */
const isHiddenList = [
  {
    url: "/child-sale/system/questionnaire/add",
  },
  {
    url: "/child-contentCenter/system/questionnaire/add",
  },
  {
    url: "/child-sale/system/questionnaire/detail",
  },
  {
    url: "/child-sale/system/questionnaire/success",
  },
  {
    url: "/child-sale/system/questionnaire/addIndex",
  },
];

export { isHiddenList };
